import { parameters } from '../../constants/parameters';
import { Log } from '../../entities/log';
import { Pagination } from '../../entities/pagination';
import * as genericApi from './generic-api';

export const list = async (token: string, params?: object): Promise<{ items: Log[]; pagination: Pagination }> => {
  const url = `${parameters.api.baseUrl}/logs-crud`;

  return genericApi.list<Log>(token, url, { ...params, with: ['user'] });
};
